import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {NgApexchartsModule} from 'ng-apexcharts';
import {FlexLayoutModule} from '@angular/flex-layout';
import {FeatherModule} from 'angular-feather';
import {allIcons} from 'angular-feather/icons';
import {PagesRoutes} from './pages.routing';
import {MaterialModule} from 'src/app/material/material.module';
import {Ng2SearchPipeModule} from 'ng2-search-filter';

/**Components**/
import {ErrorComponent} from './error/error.component';
import {VerifyCustomerComponent} from './verify-customer/verify-customer.component';
import {LeadDetailsComponent} from './verify-customer/lead-details/lead-details.component';
import {LeadsModule} from '../components/verify-customer/verify-customer.module';
import {UserDetailsComponent} from './verify-customer/user-details/user-details.component';
import {ReportsComponent} from './reports/reports.component';
import {ReportsModule} from '../components/reports/reports.module';
import {VerifyKycComponent} from './verify-customer/verify-kyc/verify-kyc.component';
import {KycDetailsComponent} from './verify-customer/kyc-details/kyc-details.component';
import {LoaderModule} from '../components/loader/loader.module';
import {DownloadComponent} from "./download/download.component";
import {ContainerOffHireComponent} from './off-hire-containers/container-off-hire/container-off-hire.component';
import {
    ValidateOffHireContainerComponent
} from './off-hire-containers/validate-off-hire-container/validate-off-hire-container.component';
import {FormFieldsModule} from "../components/form-fields/form-fields.module";
import {ControlsModule} from "../components/controls/controls.module";
import {OpsDataChangeComponent} from './ops-data-change/ops-data-change.component';
import {
    OpsDateChangeRequestDetailsComponent
} from './ops-data-change/ops-date-change-request-details/ops-date-change-request-details.component';
import {DragDropModule} from "@angular/cdk/drag-drop";
import {ExternalDashboardModule} from "../components";
import {PipesModule} from "../pipes/pipes.module";
import { OpsDateChangeListComponent } from './ops-data-change/ops-date-change-list/ops-date-change-list.component';
import { OpsDateChangeViewComponent } from './ops-data-change/ops-date-change-view/ops-date-change-view.component';

// import { FileDragNDropDirective } from '../components/master-data/custom-stepper/file-drag-n-drop.directive';

@NgModule({
    declarations: [
        ErrorComponent,
        VerifyCustomerComponent,
        LeadDetailsComponent,
        UserDetailsComponent,
        ReportsComponent,
        VerifyKycComponent,
        KycDetailsComponent,
        DownloadComponent,
        ContainerOffHireComponent,
        ValidateOffHireContainerComponent,
        OpsDataChangeComponent,
        OpsDateChangeRequestDetailsComponent,
        OpsDateChangeListComponent,
        OpsDateChangeViewComponent
        // FileDragNDropDirective
    ],
    imports: [
        MaterialModule,
        RouterModule.forChild(PagesRoutes),
        NgApexchartsModule,
        CommonModule,
        Ng2SearchPipeModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        FeatherModule.pick(allIcons),
        LeadsModule,
        ReportsModule,
        LoaderModule,
        FormFieldsModule,
        ControlsModule,
        DragDropModule,
        ExternalDashboardModule,
        PipesModule
    ],
    providers: [],
})
export class PagesModule {
}
